<template>
  <dt-illustration name="dialpad-mono-white" class="dp-home-logo" />
</template>

<style lang="less" scoped>
.dp-home-logo {
  width: auto;
  height: var(--dt-size-650);
  mix-blend-mode: overlay;
}
</style>
<script setup>
import { DtIllustration } from '@dialpad/dialtone/vue3';
</script>
